<template>
  <div class="robot clearfix" id="material">
    <div class="robot_left clearfix">
      <div class="robot_left_title">设备素材</div>
      <div class="left_content clearfix">
        <div class="content_header clearfix">
          <div class="header_box_children clearfix">
            <div class="content_header_title">素材分类</div>
            <div class="content_header_img clearfix">
              <div class="img_ One" title='新建' @click="AddClassIfy" :class="{'OneNo': isLook}"></div>
              <div class="img_ Two" title='编辑' @click="EditClassIfy" :class="{'TwoNo':contentIndexId==null||isLook}">
              </div>
              <div class="img_ Three" title='删除' @click="DelClassIfy" :class="{'ThreeNo':contentIndexId==null||isLook}">
              </div>
            </div>
          </div>
        </div>
        <div class="content_body clearfix">
          <div class="body_box" v-for="(item,index) in mothFather">
            <div class="body_box_children" :class="{active:contentIndexId==item.id}"
              @click="contentClick(item.id,item.name)">
              {{item.name}}（{{item.childrenLength}}）
            </div>
            <div class="heng"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="robot_data">
      <div class="data_top">
        <!-- <div class="buttom_form" :class="functionSetjudgeButton()" @click="handleAdd($event)">新建设备素材</div> -->
        <el-button type="primary" class="buttom_form" @click='handleAdd($event)'
          :disabled="!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook">新建设备素材</el-button>
      </div>
      <div class="data_grid">
        <el-table ref="multipleTable" :highlight-current-row="true" max-height="96%" :data="tableData"
          tooltip-effect="dark" style="width: 100%;height: 100%;" id="header-top-class">
          <el-table-column width="55">
          </el-table-column>
          <el-table-column prop="name" label="名称" width="270">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column prop="address" label="图片" width="220">
            <template slot-scope="scope">
              <div class="scopeImg" :style="{'background-image': 'url('+ImageBaseUrl+scope.row.image1 +')'}"></div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="修改时间" width="280">
            <template slot-scope="scope">
              <div style="letter-spacing: 0.5px;">{{ changeTime(scope.row.createdTime)}}</div>
            </template>
            <!--<template slot-scope="scope">{{ scope.row.createdTime }}</template>-->
          </el-table-column>
          <el-table-column prop="address" label="备注" width="410">
            <template slot-scope="scope">{{ scope.row.note }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="handleEdit(scope.row,$event)" :class="functionSetjudge()">编辑
              </el-button>
              <el-button size="small" type="text" @click="handleDelete(scope.row.id,$event)"
                :class="functionSetjudge()">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="popup">
      <!-- 验证码授权 -->
      <div class="popup-clear" v-show='functionShow' id="privilege"
        style="position: fixed; height: 349px;text-align: left;margin-left: -216px">
        <div class="popup-title">
          获取验证码授权<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i
            class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
        </div>
        <div class="popup-lab">
          手机号：
          <el-input disabled v-model="phone">{{phone}}</el-input>
        </div>
        <div class="popup-lab clearfix">
          <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
          <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode"
            @submit.native.prevent>
            <el-form-item prop="verifyCode">
              <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege"
                v-model='verifyForm.verifyCode' maxlength="4"
                @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
            </el-form-item>
          </el-form>
          <div class="code-box">
            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
          </div>
        </div>
        <div class="popup-lab">
          <p class="btn-box" style="margin-top: 26px;text-align: center;">
            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
          </p>
        </div>
      </div>
      <!-- 新增设备素材 -->
      <div class="popup-clear control" v-show='addShow' style="position: fixed; text-align: left;margin-left: -225px">
        <div class="popup-title">
          新增设备素材<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i
            class="el-icon-circle-close close" @click="close('addShow')" id="closeClear3"></i>
        </div>
        <div class="popup-lab">
          <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix">
            <el-form-item prop="name" label="名称：" autocomplete="off" class="no-title">
              <!-- <i><img :src="notes" title="名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i> -->
              <el-input v-model="ruleForm.name" style="width: 302px;"></el-input>
            </el-form-item>
            <el-form-item prop="categoryId" label="分类：" autocomplete="off" class="no-title">
              <!-- <i><img :src="notes" title="" class="notes"></i><br> -->
              <!-- <el-input v-model="ruleForm.categoryId"></el-input> -->
              <el-select v-model="ruleForm.categoryId" placeholder="请选择" class="industry" style="width: 302px;">
                <el-option v-for="item in mothFather" :key="item.id" :label="item.name" :value="item.id" v-if="item.id!=null">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="clearfix">
              <header class="tabs-box clearfix" :class="{'overflow':stateLength>4}">
                <div v-for="n in stateLength" :key="'add-tab-'+n" :class="{'active':state===(n-1)}" @click="headClick(n-1)">
                  <span>状态{{n}}</span>
                  <i v-if="n>1" @click.stop="delState(n)" class="del-icon el-icon-delete"></i>
                </div>
              </header>
              <div class="add-state" :class="{disabled:stateLength==10}" @click="stateLength<10&&stateLength++">添加状态</div>
            </div>
            <div class="upload-box">
              <div v-for="n in stateLength" v-show="state===(n-1)" :key="'add-upload-'+n">
                <el-form-item :prop="'state'+n" label="名称：" autocomplete="off" class="no-title" :key="'addState'+n">
                  <el-input v-model="ruleForm['state'+n]" style="width: 302px;"></el-input>
                </el-form-item>
                <el-form-item :prop="'image'+n" label="图片：" autocomplete="off" class="no-title" :key="'addImage'+n">
                  <el-upload class="avatar-uploader" :action="ImageBaseUrl+'/api/v1/Control/upload'"
                    :show-file-list="false" :on-success="($event) =>{handleAvatarSuccess($event,n)}">
                    <img v-if="ruleForm['image'+n]" :src="ImageBaseUrl+ruleForm['image'+n]" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>

        <div class="popup-lab">
          <p class="btn-box" style="margin-top: 26px;text-align: center;">
            <el-button type="primary" @click="createControl">确定</el-button>
            <el-button @click="close('addShow')">取消</el-button>
          </p>
        </div>
      </div>

      <!-- 编辑设备素材 -->
      <div class="popup-clear control" v-show='editShow' style="position: fixed; text-align: left;margin-left: -225px">
        <div class="popup-title">
          编辑设备素材<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i
            class="el-icon-circle-close close" @click="close('editShow')" id="closeClear3"></i>
        </div>
        <div class="popup-lab">
          <el-form :model='ruleForm' :rules="rules" ref="editForm" class="clearfix">
            <el-form-item prop="name" label="名称：" autocomplete="off" class="no-title">
              <!-- <i><img :src="notes" title="名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i> -->
              <el-input v-model="ruleForm.name" style="width: 302px;"></el-input>
            </el-form-item>
            <el-form-item prop="categoryId" label="分类：" autocomplete="off" class="no-title">
              <!-- <i><img :src="notes" title="" class="notes"></i><br> -->
              <!-- <el-input v-model="ruleForm.categoryId"></el-input> -->
              <el-select v-model="ruleForm.categoryId" placeholder="请选择" class="industry" style="width: 302px;">
                <el-option v-for="item in mothFather" :key="item.id" :label="item.name" :value="item.id" v-if="item.id!=null">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="clearfix">
              <header class="tabs-box clearfix" :class="{'overflow':stateLength>4}">
                <div v-for="n in stateLength" :key="'edit-tab-'+n" :class="{'active':state===(n-1)}" @click="headClick(n-1)">
                  <span>状态{{n}}</span>
                  <i v-if="n>1" @click.stop="delState(n)" class="del-icon el-icon-delete"></i>
                </div>
              </header>
              <div class="add-state" :class="{disabled:stateLength==10}" @click="stateLength<10&&stateLength++">添加状态</div>
            </div>
            <div class="upload-box">
              <div v-for="n in stateLength" v-show="state===(n-1)" :key="'edit-upload-'+n">
                <el-form-item :prop="'state'+n" label="名称：" autocomplete="off" class="no-title" :key="'state'+n">
                  <el-input v-model="ruleForm['state'+n]" style="width: 302px;"></el-input>
                </el-form-item>
                <el-form-item :prop="'image'+n" label="图片：" autocomplete="off" class="no-title" :key="'image'+n">
                  <el-upload class="avatar-uploader" :action="ImageBaseUrl+'/api/v1/Control/upload'"
                    :show-file-list="false" :on-success="($event) =>{handleAvatarSuccess($event,n)}">
                    <img v-if="ruleForm['image'+n]" :src="ImageBaseUrl+ruleForm['image'+n]" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>

        <div class="popup-lab">
          <p class="btn-box" style="margin-top: 26px;text-align: center;">
            <el-button type="primary" @click="updateControl">确定</el-button>
            <el-button @click="close('editShow')">取消</el-button>
          </p>
        </div>
      </div>

    </div>

    <addrobot v-for="(item,index) in addrobot" key="1" :ref="item.styleName"></addrobot>
    <mdfrobot v-for="(item,index) in mdfrobot" key="2" :ref="item.styleName"></mdfrobot>
    <addClassify v-for="(item,index) in addClassify" key="3" :ref="item.styleName"></addClassify>
    <mdfClassify v-for="(item,index) in mdfClassify" key="4" :ref="item.styleName"></mdfClassify>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex';
  import addrobot from './material/Addrobot.vue'
  import mdfrobot from './material/Mdfrobot.vue'
  import addClassify from './material/AddClassify.vue'
  import mdfClassify from './material/MdfClassify.vue'
  export default {
    components: {
      addrobot,
      mdfrobot,
      addClassify,
      mdfClassify
    },
    data() {
      return {
        addrobot: [{
          styleName: 'addrobot'
        }],
        mdfrobot: [{
          styleName: 'mdfrobot'
        }],
        addClassify: [{
          styleName: 'addClassify'
        }],
        mdfClassify: [{
          styleName: 'mdfClassify'
        }],

        //控件分类数组
        mothFather: [],
        //控件列表分类总数组
        moth: [],
        //控件列表总数组
        mothFk: [],
        //当前选中父级的索引
        contentIndexId: null,
        contentIndexName: '',
        tableData: [], //列表

        /*验证码字段*/
        notes: require('@/assets/image/organize/notes.png'),
        verifyForm: {
          verifyCode: '',
        },
        stateLength: 1,
        ruleForm: {
          name: '',
          categoryId: '',
          state1: '',
          image1: '',
          state2: '',
          image2: '',
          state3: '',
          image3: '',
          state4: '',
          image4: '',
          state5: '',
          image5: '',
          state6: '',
          image6: '',
          state7: '',
          image7: '',
          state8: '',
          image8: '',
          state9: '',
          image9: '',
          state10: '',
          image10: '',
        },
        rules: {
          verifyCode: [{ required: true,message: '请输入验证码',trigger: 'change'}],
          name: [{required: true,message: '请输入素材名称',trigger: 'change'}],
          categoryId: [{required: true,message: '请选择素材类型',trigger: 'change'}],
          image1: [{required: true,message: '请上传素材状态1的图片',trigger: 'change'}],
          state1: [{required: true,message: '请输入素材状态1的名称',trigger: 'change'}],
          image2: [{required: true,message: '请上传素材状态2的图片',trigger: 'change'}],
          state2: [{required: true,message: '请输入素材状态2的名称',trigger: 'change'}],
          image3: [{required: true,message: '请上传素材状态3的图片',trigger: 'change'}],
          state3: [{required: true,message: '请输入素材状态3的名称',trigger: 'change'}],
          image4: [{required: true,message: '请上传素材状态4的图片',trigger: 'change'}],
          state4: [{required: true,message: '请输入素材状态4的名称',trigger: 'change'}],
          image5: [{required: true,message: '请上传素材状态5的图片',trigger: 'change'}],
          state5: [{required: true,message: '请输入素材状态5的名称',trigger: 'change'}],
          image6: [{required: true,message: '请上传素材状态6的图片',trigger: 'change'}],
          state6: [{required: true,message: '请输入素材状态6的名称',trigger: 'change'}],
          image7: [{required: true,message: '请上传素材状态7的图片',trigger: 'change'}],
          state7: [{required: true,message: '请输入素材状态7的名称',trigger: 'change'}],
          image8: [{required: true,message: '请上传素材状态8的图片',trigger: 'change'}],
          state8: [{required: true,message: '请输入素材状态8的名称',trigger: 'change'}],
          image9: [{required: true,message: '请上传素材状态9的图片',trigger: 'change'}],
          state9: [{required: true,message: '请输入素材状态9的名称',trigger: 'change'}],
          image10: [{required: true,message: '请上传素材状态10的图片',trigger: 'change'}],
          state10: [{required: true,message: '请输入素材状态10的名称',trigger: 'change'}],
        },
        functionShow: false,
        editShow: false,
        addShow: false,
        VerifyArr: [],
        verifyCode: '',
        second: 60,
        getCodeShow: true,
        countdownShow: false,
        phone: '',
        time: null,
        state: 0
      }
    },
    computed: {
      ...mapState("defaultImgOptions", {
        ImageBaseUrl: 'ImageBaseUrl',
      }),
      companyId() {
        return this.$store.state.companyId;
      },
      functionList() {
        return this.$store.state.functionList;
      },
      isLook() {
        return this.$store.state.isLook;
      },
    },
    created() {
      this.$store.state.activeIndex = '/material'
      this.phone = this.hidePhone(this.$store.state.userData.mobile);
      this.getData();
    },
    mounted() {
      this.TypeListUpdata();
    },
    methods: {
      // 创建设备素材
      createControl() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.postNoJson('/v2/Control/create', this.ruleForm).then(res => {
              // console.log(res)
              if (res.success) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.TypeListUpdata()
                this.close('addShow')
              } else {
                this.$message({
                  message: '创建失败：' + res.message,
                  type: 'warning'
                });
              }
            })
          } else {
            for (let n = 1; n <= this.stateLength; n++) {
              if (!this.ruleForm['image' + n] || !this.ruleForm['state' + n]) {
                this.state = n - 1
                break
              }
            }
            return false;
          }
        });
      },
      // 创建设备素材
      updateControl() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.postNoJson('/v2/Control/update', this.ruleForm).then(res => {
              // console.log(res)
              if (res.success) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                });
                this.TypeListUpdata()
                this.close('editShow')
              } else {
                this.$message({
                  message: '编辑失败：' + res.message,
                  type: 'warning'
                });
              }
            })
          } else {
            for (let n = 1; n <= this.stateLength; n++) {
              if (!this.ruleForm['image' + n] || !this.ruleForm['state' + n]) {
                this.state = n - 1
                break
              }
            }
            return false;
          }
        });
      },

      /*验证码函数*/
      // 获取验证码
      getCode() {
        this.get('/UserProfile/sendVerifyCode').then((res) => {
          if (res.success) {
            this.getCodeShow = false
            this.countdownShow = true
            const TIME_COUNT = 60;
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            });
            if (!this.timer) {
              this.second = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.second > 0 && this.second <= TIME_COUNT) {
                  this.second--;
                } else {
                  this.getCodeShow = true;
                  this.countdownShow = false;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          } else {
            this.$message({
              message: `验证码发送失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 用户提权
      Privilege() {
        this.$refs.verifyCode.validate((valid) => {
          if (valid) {
            this.post('/UserProfile/privilege', {
              verifyCode: this.verifyForm.verifyCode
            }).then(res => {
              if (res.success) {
                this.$message({
                  message: '提权成功',
                  type: 'success'
                })
                this.VerifyArr.splice(this.VerifyArr.indexOf(10), 1)
                localStorage.setItem('verifyCodeModule', this.VerifyArr)
                this.$store.state.mask = false
                this.functionShow = false
                this.getCodeShow = true;
                this.countdownShow = false;
                clearInterval(this.timer);
                this.timer = null;
                this.verifyForm.verifyCode = ''
              } else {
                this.$message({
                  message: `提权失败：${res.message}`,
                  type: 'warning'
                })
              }
            })
          }
        })
      },
      headClick(i) {
        this.state = i;
      },
      delState(i) {
        if (i < 1 || i > this.stateLength) return
        for (let k = i; k < this.stateLength; k++) {
          this.ruleForm['image' + k] = this.ruleForm['image' + (k + 1)] || ''
          this.ruleForm['state' + k] = this.ruleForm['state' + (k + 1)] || ''
        }
        this.ruleForm['image' + this.stateLength] = ''
        this.ruleForm['state' + this.stateLength] = ''
        if (this.state >= this.stateLength - 1) {
          this.state = Math.max(0, this.state - 1)
        }
        this.stateLength--
      },
      handleAvatarSuccess(e, i) {
        console.log(e, i)
        this.ruleForm['image' + i] = e
        if(this.addShow){
          this.$refs.addForm.validateField('image' + i)
        }else{
          this.$refs.editForm.validateField('image' + i)
        }
      },
      close(name) {
        this[name] = false;
        this.$store.state.mask = false;
        if (name == 'functionShow') {
          this.verifyForm.verifyCode = ''
        } else {
          this.ruleForm = this.$options.data().ruleForm
        }
      },
      //获取系统配置
      getData() {
        this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
      },

      /*权限判断*/
      functionSetjudge() {
        if (!this.functionList.includes('systemConfigEdit') || this.isLook) {
          return 'noset'
        }
      },
      /*权限判断*/
      functionSetjudgeButton() {
        if (!this.functionList.includes('systemConfigEdit') || this.isLook) {
          return 'ButtonNoset'
        }
      },
      TypeListUpdata() {
        let self = this;
        /*更新字典分类*/
        self.get('/v2/Control/getList', {}).then((res) => {
          if (res.success) {
            //分类
            self.ArrayClassify(res.result)
            self.mothFk = res.result;
            self.tableData = res.result
            /*获取字典分类*/
            self.get('/Dict/getListByType', {
              type: 4
            }).then((res) => {
              if (res.success == true) {
                self.mothFather = res.result;
                for (var a = 0; a < self.mothFather.length; a++) {
                  self.mothFather[a].childrenLength = 0;
                  for (var i = 0; i < self.moth.length; i++) {
                    if (self.moth[i].father_id == self.mothFather[a].id) {
                      self.mothFather[a].childrenLength = self.moth[i].children.length;
                    }
                  }
                }
                self.mothFather.unshift({
                  id: null,
                  name: '全部',
                  childrenLength: self.tableData.length
                })
                this.$forceUpdate()
              }
            })
          }
        })
      },
      TableDataUpdata() {
        /*更新表格*/
        this.get('/v2/Control/getList', {}).then((res) => {
          if (res.success == true) {
            //分类
            this.ArrayClassify(res.result)
            this.mothFk = res.result;
            if (this.contentIndexId == null) {
              this.tableData = this.mothFk;
            } else {
              if (this.moth.filter(item => item.father_id == this.contentIndexId).length == 0) {
                this.tableData = [];
              } else {
                this.tableData = this.moth.filter(item => item.father_id == this.contentIndexId)[0].children;
              }
            }
          }
        })
      },
      AddClassIfy() {
        if (this.isLook) return;

        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        /*新增类别*/
        this.AddClassify();
      },
      EditClassIfy() {
        if (this.isLook) return;

        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        /*修改类别*/
        if (this.contentIndexId != null) {
          this.MdfClassify();
        }
      },
      DelClassIfy() {
        if (this.isLook) return;
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        /*删除类别*/
        if (this.contentIndexId != null) {
          this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.get('/Dict/remove', {
              id: this.contentIndexId
            }).then((res) => {
              if (res.success == true) {
                this.TypeListUpdata();
                this.contentIndexId = null;
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success'
                });
              }
            })
          })
        }
      },
      contentClick(id, name) {
        if (id == this.contentIndexId) {
          this.contentIndexId = null;
          this.contentIndexName = '';
        } else {
          this.contentIndexId = id;
          this.contentIndexName = name;
        }
      },
      ArrayClassify(ObjectData) {
        var moth = [],
          flag = 0,
          list = ObjectData;
        var wdy = {
          father_id: '',
          father_name: '',
          children: ''
        }
        for (var i = 0; i < list.length; i++) {
          var az = '';
          for (var j = 0; j < moth.length; j++) {
            if (moth[j].father_id == list[i]['categoryId']) {
              flag = 1;
              az = j;
              break;
            }
          }
          if (flag == 1) {
            var ab = moth[az];
            ab.children.push(list[i]);
            flag = 0;

          } else if (flag == 0) {
            wdy = {};
            wdy.father_id = list[i]['categoryId'];
            wdy.father_name = list[i]['categoryName'];
            wdy.children = new Array();
            wdy.children.push(list[i]);
            moth.push(wdy);
          }
        }
        this.moth = moth;
      },

      scopeImg(Imgurl) {
        return {
          backgroundImage: 'url(' + Imgurl + ')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '100% 100%'
        }
      },
      handleAdd(v) {
        if (this.isLook) return;
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!v.srcElement.className.split(' ').includes('ButtonNoset')) {
          this.Addrobot();
        }
      },
      handleEdit(objectData, v) {
        if (this.isLook) return;
        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!v.srcElement.parentNode.className.split(' ').includes('noset')) {
          this.editCategory(objectData);
        }
      },
      editCategory(objectData) {
        this.get('/v2/Control/get', {
          id: objectData.id
        }).then(res => {
          if (res.success == true) {
            this.ruleForm = res.result
            this.ensureRuleFormFields()
            this.editShow=true
            this.$store.state.mask = true
            let maxLen = 1
            for (let n = 10; n >= 1; n--) {
              if (this.ruleForm['state' + n] || this.ruleForm['image' + n]) {
                maxLen = n
                break
              }
            }
            this.stateLength = maxLen
            this.state = 0 
            document.getElementsByClassName('mask')[0].style.opacity = '0';
            document.getElementsByClassName('mask')[0].style.transition = '.1s';
            setTimeout(function() {
              document.getElementsByClassName('mask')[0].style.opacity = '1';
            }, 50)
          } else {
            this.$message({
              message: `获取素材失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      ensureRuleFormFields() {
        for (let n = 1; n <= 10; n++) {
          if (typeof this.ruleForm['state' + n] === 'undefined') this.$set(this.ruleForm, 'state' + n, '')
          if (typeof this.ruleForm['image' + n] === 'undefined') this.$set(this.ruleForm, 'image' + n, '')
        }
      },
      handleDelete(id, v) {
        if (this.isLook) return;

        if (this.VerifyArr.includes(10)) {
          this.functionShow = true;
          this.$store.state.mask = true;
          return
        }
        if (!v.srcElement.parentNode.className.split(' ').includes('noset')) {
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.get('/v2/Control/remove', {
              id: id
            }).then((res) => {
              if (res.success == true) {
                this.$message({
                  showClose: true,
                  message:"删除成功",
                  type:"success"
                });
                this.TypeListUpdata();
              }
            })
          });
        }
      },
      MdfClassify() {
        var self = this;
        if (this.$refs.mdfClassify[0].$el.style.display == "" || this.$refs.mdfClassify[0].$el.style.display ==
          "none") {
          this.$refs.mdfClassify[0].binding({
            id: this.contentIndexId,
            name: this.contentIndexName
          });
          this.$refs.mdfClassify[0].$el.style.display = "block";
          self.$store.state.mask = true;
          document.getElementsByClassName('mask')[0].style.opacity = '0';
          document.getElementsByClassName('mask')[0].style.transition = '.1s';
          setTimeout(function() {
            self.$refs.mdfClassify[0].$el.style.opacity = 1;
            self.$refs.mdfClassify[0].$children[0].$el.style.top = 0 + 'px';
            document.getElementsByClassName('mask')[0].style.opacity = '1';
          }, 50)
        } else {
          this.$refs.mdfClassify[0].$el.style.opacity = 0;
          self.$refs.mdfClassify[0].$children[0].$el.style.top = -50 + 'px';
          self.$store.state.mask = false;
          setTimeout(function() {
            self.$refs.mdfClassify[0].$el.style.display = "none";
          }, 100)
        }
      },
      AddClassify() {
        var self = this;
        if (this.$refs.addClassify[0].$el.style.display == "" || this.$refs.addClassify[0].$el.style.display ==
          "none") {
          this.$refs.addClassify[0].$el.style.display = "block";
          self.$store.state.mask = true 
          document.getElementsByClassName('mask')[0].style.opacity = '0';
          document.getElementsByClassName('mask')[0].style.transition = '.1s';
          setTimeout(function() {
            self.$refs.addClassify[0].$el.style.opacity = 1;
            self.$refs.addClassify[0].$children[0].$el.style.top = 0 + 'px';
            document.getElementsByClassName('mask')[0].style.opacity = '1';
          }, 50)
        } else {
          this.$refs.addClassify[0].$el.style.opacity = 0;
          self.$refs.addClassify[0].$children[0].$el.style.top = -50 + 'px';
          self.$store.state.mask = false;
          setTimeout(function() {
            self.$refs.addClassify[0].$el.style.display = "none";
          }, 100)
        }
      },
      Mdfrobot(objectData) {
        // var self = this;
        // if(this.$refs.mdfrobot[0].$el.style.display == "" || this.$refs.mdfrobot[0].$el.style.display == "none") {
        // 	this.$refs.mdfrobot[0].binding(objectData, this.mothFather);
        // 	this.$refs.mdfrobot[0].$el.style.display = "block";
        // 	self.$store.state.mask = true;
        // 	document.getElementsByClassName('mask')[0].style.opacity = '0';
        // 	document.getElementsByClassName('mask')[0].style.transition = '.1s';
        // 	setTimeout(function() {
        // 		self.$refs.mdfrobot[0].$el.style.opacity = 1;
        // 		self.$refs.mdfrobot[0].$children[0].$el.style.top = 0 + 'px';
        // 		document.getElementsByClassName('mask')[0].style.opacity = '1';
        // 	}, 50)
        // } else {
        // 	this.$refs.mdfrobot[0].$el.style.opacity = 0;
        // 	self.$refs.mdfrobot[0].$children[0].$el.style.top = -50 + 'px';
        // 	self.$store.state.mask = false;
        // 	setTimeout(function() {
        // 		self.$refs.mdfrobot[0].$el.style.display = "none";
        // 	}, 100)
        // }
        console.log(objectData)
      },
      Addrobot() {
        // var self = this;
        // if(this.$refs.addrobot[0].$el.style.display == "" || this.$refs.addrobot[0].$el.style.display == "none") {
        // 	this.$refs.addrobot[0].binding(this.mothFather);
        // 	this.$refs.addrobot[0].$el.style.display = "block";
        // 	self.$store.state.mask = true;
        // 	document.getElementsByClassName('mask')[0].style.opacity = '0';
        // 	document.getElementsByClassName('mask')[0].style.transition = '.1s';
        // 	setTimeout(function() {
        // 		self.$refs.addrobot[0].$el.style.opacity = 1;
        // 		self.$refs.addrobot[0].$children[0].$el.style.top = 0 + 'px';
        // 		document.getElementsByClassName('mask')[0].style.opacity = '1';
        // 	}, 50)
        // } else {
        // 	this.$refs.addrobot[0].$el.style.opacity = 0;
        // 	self.$refs.addrobot[0].$children[0].$el.style.top = -50 + 'px';
        // 	self.$store.state.mask = false;
        // 	setTimeout(function() {
        // 		self.$refs.addrobot[0].$el.style.display = "none";
        // 	}, 100)
        // }
        this.state = 0
        this.stateLength = 1
        this.addShow = true
        this.$store.state.mask = true
        this.$refs.addForm.resetFields()
      },
    },
    watch: {
      contentIndexId(val) {
        if (val == null) {
          this.tableData = this.mothFk;
        } else {
          if (this.moth.filter(item => item.father_id == val).length == 0) {
            this.tableData = [];
          } else {
            this.tableData = this.moth.filter(item => item.father_id == val)[0].children;
          }
        }
      }
    }
  }
</script>

<!-- 三期新加样式 -->
<style scoped lang="scss">
  .add-state {
    float: right;
    color: #5087e4;
    cursor: pointer;

    &.disabled {
      color: #d2d2d2;
      cursor: not-allowed;
    }
  }

  .avatar-uploader {
    margin-top: 4px;
  }

  .avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader>>>.el-upload:hover {
    border-color: #5087e4;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }

  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }

  .control {
    width: 450px !important;
    height: 570px;
  }

  .upload-box {
    width: 100%;
    height: 240px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #d2d2d2;

    .upload-text {
      color: #5087e4;
      cursor: pointer;
      line-height: 40px;
    }
  }
</style>

<style scoped>
  .form {
    width: 100%;
    height: 269px;
  }

  .tabs-box {
    text-align: center;
    /* width: 242px; */
    float: left;
    overflow: hidden;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    border-bottom: none;
    display: flex;
    max-width: 324px;
  }
  .tabs-box.overflow {
    overflow: auto;
    padding-bottom: 2px;
  }

  .tabs-box div {
    float: left;
    padding: 8px 0;
    box-sizing: border-box;
    min-height: 34px;
    position: relative;
  }

  .tabs-box div:hover i {
    display: inline-block;
    cursor: pointer;
  }

  .del-icon {
    display: none;
    font-size: 14px;
    color: red;
    position: absolute;
    right: 2px;
    top: 2px;
  }

  .tabs-box span {
    display: inline-block;
    width: 80px;
    font-size: 14px;
    line-height: 18px;
    border-left: 1px solid #e2e2e2;
    cursor: pointer;
    float: left;
  }

  .tabs-box>div:first-child span {
    border: none;
  }

  .active {
    background: #5087e4;
    color: #fff;
  }

  .active>span {
    border: 0;
  }

  .active i {
    color: #fff;
  }


  /*验证码css*/
  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popup>div {
    position: fixed !important;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -407px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .btn-box {
    position: relative;
    margin-top: 260px;
  }

  .btn-box2 {
    text-align: center;
    width: 100%;
    margin-top: 46px;
  }

  .btn-box>p {
    margin-top: 10px;
    color: #909090;
  }




  .ButtonNoset {
    background-color: #a0cfff !important;
    border-color: #a0cfff !important;
    cursor: not-allowed !important;
  }

  .heng {
    width: calc(100% - 24px);
    height: 1px;
    background-color: #eee;
    float: left;
    padding: 0 13px 0 11px;
  }

  .body_box_children.active {
    background-color: #EEEEEE;
  }

  .body_box_children:hover {
    background-color: #EEEEEE;
  }

  .body_box_children {
    /* border-bottom: 1px solid #EEEEEE; */
    text-indent: 20px;
    transition: .2s;
  }

  .body_box {
    padding: 0;
    color: #636363;
    float: left;
    width: 100%;
    cursor: pointer;
    -webkit-transition: .2s;
    transition: .2s;
  }

  .content_body {
    float: left;
    /* border-bottom: 1px solid #E5E5E5; */
    width: 100%;
    line-height: 54px;
    text-align: left;
    overflow: auto;
    position: absolute;
    max-height: 100%;
    top: 52px;
    bottom: 20px;
  }

  .header_box_children {
    border-bottom: 1px solid #EEEEEE;
    text-indent: 15px;
  }

  .header_box {
    padding: 0 13px 0 11px;
    border-bottom: 1px solid #EEEEEE;
    width: calc(100% - 24px);
    height: 100%;
  }

  .content_header_img .img_ {
    margin-left: 12px;
    width: 18px;
    height: 20px;
    cursor: pointer;
    float: left;
    margin-top: 20px;
  }

  .content_header_img .img_.One {
    background-image: url(../../assets/image/organize/add.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header_img .img_.OneNo {
    background-image: url(../../assets/image/organize/add3.png) !important;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
    cursor: not-allowed;
  }

  .content_header_img .img_.Two {
    background-image: url(../../assets/image/organize/edit.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header_img .img_.TwoNo {
    background-image: url(../../assets/image/organize/edit3.png) !important;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
    cursor: not-allowed;
  }

  .content_header_img .img_.Three {
    background-image: url(../../assets/image/organize/delete.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header_img .img_.ThreeNo {
    background-image: url(../../assets/image/organize/delete3.png) !important;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
    cursor: not-allowed;
  }

  .content_header_img .img_.One:hover {
    background-image: url(../../assets/image/organize/add2.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header_img .img_.Two:hover {
    background-image: url(../../assets/image/organize/edit2.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header_img .img_.Three:hover {
    background-image: url(../../assets/image/organize/delete2.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .TJCloud .content_header_img .img_.One:hover {
    background-image: url(../../assets/image/organize/add4.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .TJCloud .content_header_img .img_.Two:hover {
    background-image: url(../../assets/image/organize/edit4.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .TJCloud .content_header_img .img_.Three:hover {
    background-image: url(../../assets/image/organize/delete4.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 18px;
  }

  .content_header {
    float: left;
    /* border-bottom: 1px solid #E5E5E5; */
    width: 100%;
    line-height: 51px;
    text-align: left;
    /*padding: 0 13px 0 11px;*/
  }

  .content_header_title {
    color: #3A3A3A;
    font-size: 13px;
    line-height: 51px;
    float: left;
  }

  .content_header_img {
    float: right;
    height: 51px;
    width: 90px;
    position: relative;
    right: 12px;
  }

  .robot_left {
    float: left;
    margin-left: 16px;
    margin-right: 14px;
    height: 100%;
    width: 216px;
    position: relative;
  }

  .robot_left_title {
    float: left;
    width: 100%;
    line-height: 55px;
    color: #2c3e50;
    font-size: 16px;
    text-align: left;
    position: relative;
    top: -16px;
    left: 3px;
  }

  .left_content {
    float: left;
    width: 100%;
    height: calc(100% - 33px);
    position: relative;
    /* padding: 0 11px 0 13px; */
    background-color: #fff;
    position: relative;
    top: -20px;
    border-radius: 5px;
  }

  #header-top-class {
    border: 1px solid #f2f2f2;
    /*border-radius: 5px;*/
    /*border-bottom: 0;*/
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  #header-top-class>>>.cell {
    font-size: 14px;
    min-width: 95px;
  }

  #header-top-class>>>.has-gutter tr,
  #header-top-class>>>.has-gutter th {
    background-color: #EEEEEE;
    font-weight: unset !important;
    padding: 10px 0 !important;
    color: #636363 !important;
  }

  #header-top-class>>>.el-table__header-wrapper {
    /*border-radius: 5px 5px 0px 0px;*/
  }

  #header-top-class>>>.el-table__body {
    width: 100% !important;
  }

  /*滚动条样式：谷歌浏览器下*/

  /*#header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: #f5f7fa;
	}*/
  /*滚动条的轨道*/

  /*#header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-track {
		background-color: #FAFAFA;
	}*/
  /*滚动条的滑块按钮*/

  /*#header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: #C2C2C2;
	}*/
  /*滚动条的上下两端的按钮*/

  /*#header-top-class>>>.el-table__body-wrapper::-webkit-scrollbar-button {
		height: 0px;
		width: 0px;
	}*/

  .scopeImg {
    width: 23px;
    height: 23px;
    text-align: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .data_grid {
    width: 100%;
    height: 95%;
    background-color: #fff;
  }

  .data_grid>>>.el-pagination {
    position: absolute;
    bottom: 51px;
    left: 20px;
    padding-left: 30px;
  }

  .robot_data {
    background-color: #fff;
    width: calc(100% - 286px);
    height: calc(100% - 91px);
    /* margin-top: 6px; */
    padding: 25px 20px;
    margin-top: 33px;
    float: left;
  }

  .data_top {
    width: 100%;
    /* padding: 30px; */
    height: 40px;
    margin-bottom: 20px;
  }

  .data_top .buttom_form {
    float: left;
    /* border: 1px solid #5087E4; */
    border-radius: 3px;
    color: #fff;
    /* width: 100px; */
    height: 40px;
    cursor: pointer;
    background-color: #5087E4;
    font-size: 14.5px;
    text-align: center;
    line-height: 41px;
    padding: 0 15px 0 15px;
    margin-right: 30px;
    -webkit-transition: .1s;
    transition: .1s;
    min-width: 80px;
  }

  .data_top .buttom_form:hover {
    background-color: #376cc7;
    color: #fff;
  }

  .rightMar {
    margin-right: 94px !important;
  }

  .rightMarTwo {
    margin-right: 80px !important;
  }

  .cursom {
    margin-right: 30px;
  }

  .robot {
    /* text-align: left; */
    /* padding: 20px; */
    /* padding-top: 90px; */
    width: 100%;
    height: 100%;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .select_time {
    width: 100%;
    height: 88px;
    background: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .fleft {
    float: left;
    padding-top: 21px;
    padding-bottom: 27px;
  }

  .pickTime {
    margin-left: 30px;
  }

  .addtime {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-right: 13px;
  }

  .el-date-editor {
    border: 0;
    padding: 0;
  }

  .el-date-editor>>>.el-range-input {
    border: 1px solid rgba(194, 194, 194, 1);
    border-radius: 2px;
    cursor: pointer;
  }

  .el-date-editor>>>.el-range__icon {
    display: none;
  }

  .el-date-editor>>>.el-range-separator {
    padding: 0 13px;
    line-height: 43px;
    width: 5%;
    color: #A1A1A1;
  }

  .el-date-editor>>>.el-range__close-icon {
    font-size: 17px;
    color: #C0C4CC;
    width: 25px;
    display: inline-block;
    float: right;
    line-height: 40px;
    position: absolute;
    right: 30px;
  }

  .static {
    position: relative;
    margin-right: 30px;
  }

  .static span {
    position: absolute;
    color: #333333;
    font-size: 14px;
    z-index: 3;
    top: 31px;
    left: 11px;
  }

  .cur .el-select>>>.el-input .el-input__inner {
    width: 290px !important;
  }

  .ksbh .el-select>>>.el-input .el-input__inner {
    width: 140px !important;
  }

  .zt .el-select>>>.el-input .el-input__inner {
    width: 166px !important;
  }

  .cursom>>>.el-input .el-input__inner {
    width: 155px !important;
  }

  /* .el-select>>>.el-input .el-input__inner {
		border-radius: 2px;
		border: 1px solid rgba(194, 194, 194, 1);
		text-indent: 61px;
		width: 186px;
		height: 40px;
		z-index: 2;
		text-align: right !important;
	} */

  .cursom>>>.el-input .el-input__inner {
    border: 1px solid rgba(194, 194, 194, 1);
    border-radius: 2px;
  }

  .el-select-dropdown {
    max-width: 186px !important;
  }

  .el-scrollbar>>>.el-select-dropdown__list:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

  .butto {
    width: 100px;
    height: 40px;
  }

  .butto>>>.el-button--text {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    background-color: #CA3A41;
    font-size: 17px;
  }

  .el-table>>>td div {
    white-space: normal !important;
  }

  .el-table>>>.el-table__body tr:hover>td {
    background-color: #e9e9e9 !important;
    padding: 5.5px 0 !important;
    border-bottom: 1px solid #f2f2f2 !important;
  }

  #header-top-class>>>.cell .el-button span {
    font-size: 14px !important;
    color: #5087e4;
  }

  .el-table>>>.el-table__row:hover {
    background-color: transparent !important;
  }

  .el-table>>>.el-table__body tr>td {
    padding: 5.5px 0 !important;
    transition: unset !important;
    border-bottom: 1px solid #f2f2f2 !important;
  }

  .el-table>>>.el-table__body tr.current-row>td {
    background-color: #e9e9e9 !important;
    padding: 5.5px 0 !important;
  }

  /*.el-table>>>.el-table__body-wrapper{
		max-height: 551px;
	}*/
  .el-table>>>.el-table__body tr:nth-last-child(1)>td {
    border-bottom: 0px !important;
  }

  .el-table::before {
    background-color: unset !important;
  }

  .noset {
    color: #A0CFFF;
    cursor: not-allowed;
  }
</style>
<style>
  #header-top-class.el-table--scrollable-y .el-table__body-wrapper {
    height: 96% !important;
  }

  #material .popup .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }

  #material .popup .el-form-item {
    width: 100% !important;
    margin-bottom: 16px !important;
  }

  #material .popup .el-form-item__label {
    padding: 0 !important;
  }

  #material .popup .el-form-item__content {
    line-height: 34px !important;
  }

  #material .search .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }

  #material .popup .el-select .el-input__icon {
    line-height: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SetUp/material.vue